export default "__VITE_ASSET__wg8ixYDB__";